import * as permissions from './permissions';

type RouteInfoType = {
  title: string;
  relativeUrl: string;
  pathMatch: string;
};

export type SubMenuType = {
  routeInfo: RouteInfoType;
  checkPermission: boolean;
  permissions: string[];
};
export const settingsSubMenuItems = {
  GUARDRAILS: {
    routeInfo: {
      title: 'Guardrails',
      link: `settings/guardrails`,
      pathMatch: 'prefix',
    },
    checkPermission: false,
  },
  USER_MANAGEMENT: {
    routeInfo: {
      title: 'User Management',
      link: `settings/users`,
      pathMatch: 'prefix',
    },
    checkPermission: true,
    permissions: [
      ...permissions.USER_PERMISSIONS,
      ...permissions.USER_GROUP_PERMISSIONS,
      ...permissions.CUSTOM_ROLE_PERMISSIONS,
    ],
  },
  OAUTH_INTEGRATION: {
    routeInfo: {
      title: 'OAuth integrations',
      link: `settings/oauthClients`,
      pathMatch: 'prefix',
    },
    checkPermission: true,
    permissions: permissions.OAUTH_INTEGRATION_PERMISSIONS,
  },
  NOTIFICATIONS: {
    routeInfo: {
      title: 'Notifications',
      link: `settings/notification-center`,
      pathMatch: 'prefix',
    },
    checkPermission: false,
    permissions: [
      ...permissions.CHANNEL_PERMISSIONS,
      ...permissions.SUBSCRIPTION_PERMISSIONS,
    ],
  },
  ARTIFACTORY: {
    routeInfo: {
      title: 'Container Registries',
      link: `settings/artifactories`,
      pathMatch: 'prefix',
    },
    checkPermission: true,
    permissions: permissions.ARTIFACTORY_PERMISSIONS,
  },
  ACCOUNT_MANAGEMENT: {
    routeInfo: {
      title: 'Account Management',
      link: `settings/organization-accounts`,
      pathMatch: 'prefix',
    },
    checkPermission: true,
    permissions: permissions.ACCOUNTS_PERMISSIONS,
  },
  CP_SETTINGS: {
    routeInfo: {
      title: 'General',
      link: `settings`,
      pathMatch: 'prefix',
    },
    checkPermission: true,
    permissions: [permissions.ROLE_CC_ADMIN],
  },
};
